<template>
  <div id="app">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout justify-center align-center >
            <v-flex xs8 sm4 md4>
              <v-card class="elevation-18">
                <div align="center">
                <img src="../../assets/inscora-logo.jpg">
                  <v-layout align-center justify-center title>OHS(OCCUPATIONAL HEALTH SERVICES)</v-layout>
                </div>
                <v-card-text>
                  <v-form>
                    <v-text-field prepend-icon="person" name="Username" label="Usuario" v-model="username"></v-text-field>
                    <v-text-field prepend-icon="lock" name="Password" label="Password" type="password" v-model="password" v-on:keyup.enter="login"></v-text-field>
                    <p v-if="this.$store.state.errorLogin"  class="text-sm-center warning--text" color="cyan darken-1">Usuario o contraseña incorrectos</p>
                    <div class="text-sm-center"><a @click="openDialogRequestPasswordReset" @click.stop="dialogPassword = true">¿Olvidó su contraseña?</a></div>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn  class="mx-2" color="primary" large block v-on:click="login" >Entrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <!--MODAL PARA INGRESAR EL CORREO Y RECUPERAR LA CONTRASEÑA.-->
          <v-dialog v-model="dialogPassword" max-width="500px">-->
            <v-card>
              <div>
                <div class="headline">
                  <v-card-title primary-title>Recuperar Contraseña</v-card-title>
                </div>
              </div>
              <v-card-text>
                <v-form v-model="valid">
                  Ingrese su correo electrónico para recuperar su contraseña
                  <v-text-field prepend-icon="email" :rules="emailRules" name="Correo electrónico" label="Correo electrónico" v-model="mailResetPassword"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="grey darken-4" flat  :disabled="!valid" @click="requestPasswordReset">Enviar</v-btn>
                <v-btn color="grey darken-1" flat @click.stop="dialogPassword=false">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-model="alert" color="error" dismissible>{{error}}</v-alert>
          </v-dialog>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        valid:false,
        username: '',
        password: '',
        mailResetPassword: '',
        dialogPassword: false,
        dialogPasswordSuccess: false,
        error: "",
        alert: false,
        emailRules: [
          v => !!v || 'El email es requerido',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
        ],
      }
    },
    methods: {
      login () {
        this.$store.dispatch('loadUsuario', {username: this.username, password: this.password}).then(response => {
        }, error => {
          this.$store.state.progress = false
          this.$store.state.dialogError = true
        })
      },
      openDialogRequestPasswordReset(){
        this.error= ""
        this.alert= false
        this.mailResetPassword= ""
      },
      requestPasswordReset () {
        if(this.checkFormResetPassword()){
          this.$store.dispatch('requestPasswordReset', this.mailResetPassword).then(response => {
          })
        }
        this.dialogPassword = false
      },
      cancelar(){
        this.username=""
        this.password=""
      },
      checkFormResetPassword(){
        if(this.mailResetPassword===""){
          this.error= "Debe ingresar el usuario para recuperar la contraseña"
          this.alert=true
          return false
        }
        return true
      }
    }
  }
</script>

<style lang="css" scoped>
  .container{
    background-image: url("../../assets/medical2.jpg");
    background-repeat: no-repeat;
    background-position: center center;
    background-color: #006699;
    background-attachment: fixed;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue